import React from 'react'
import { ApiUser } from '@vend/types'
import { useT } from '@transifex/react'
import classNames from 'classnames'

import { SearchableList } from '../SearchableList'
import { matchesUserSearch } from '../../../models/user'
import { SearchableUserBadge } from '../SearchableUserBadge'

export interface SearchableUserListProps {
  users: ApiUser[]
  activeUserId?: string
  onSelectHandler: (user: ApiUser) => void
}

export const SearchableUserList = (props: SearchableUserListProps) => {
  const t = useT()

  return (
    <SearchableList
      items={props.users}
      getKey={user => user.id}
      filterFn={matchesUserSearch}
      label={t('Choose from users in your outlet')}
      searchPlaceholder={t('Search for a user')}
      autoFocus
      activeKey={props.activeUserId}
      onItemSelect={props.onSelectHandler}
      renderItem={(user, isActive, keyword) => (
        <div
          className={classNames(
            'typography-body-sm text-neutral-default min-h-12 cursor-pointer py-3 pl-6 transition-colors duration-200 hover:bg-go-highlight-default',
            { 'bg-go-highlight-default': isActive }
          )}
        >
          <SearchableUserBadge user={user} keyword={keyword} />
        </div>
      )}
    />
  )
}
